import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import LoginPage from '../pages/Auth/LoginPage';
import RegisterPage from '../pages/Auth/RegisterPage';

import Dashboard from '../pages/App/dashboard';
import Home from '../pages/Home';
import Beneficiaries from '../pages/App/dashboard/Beneficiaries';
import Notifications from '../pages/App/dashboard/Notifications';
import Settings from '../pages/App/dashboard/Settings';
import Rewards from '../pages/App/dashboard/Rewards';
import Wallet from '../pages/App/dashboard/Wallet';
import BeneficiaryContextProvider from '../contexts/BeneficiaryContext';

const AppNavigation = () => {
  return (
    <Switch>
      <Route path="/" exact render={(props) => <Home />} />
      <Route path="/login" exact render={(props) => <LoginPage />} />
      <Route path="/register" exact render={(props) => <RegisterPage />} />
      <Route path="/dashboard" exact render={(props) => <Dashboard />} />
      <Route path="/dashboard/wallet" exact render={(props) => <Wallet />} />
      <BeneficiaryContextProvider>
        <Route
          path="/dashboard/beneficiaries"
          exact
          render={(props) => <Beneficiaries />}
        />
        <Route
          path="/dashboard/notifications"
          exact
          render={(props) => <Notifications />}
        />
        <Route
          path="/dashboard/settings"
          exact
          render={(props) => <Settings />}
        />
        <Route
          path="/dashboard/rewards"
          exact
          render={(props) => <Rewards />}
        />
      </BeneficiaryContextProvider>
    </Switch>
  );
};
export default AppNavigation;
